import { FC, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";

import { Icon, Panel } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Paragraph, Semibold } from "capitalrx-components-2.0/lib/typography";

import { MemberNotification } from "@/App/api/notification";
import { ANALYTIC_EVENTS, logEvent } from "@/App/service/analyticsService";

export const AdherenceMessage: FC<{ readonly memberNotification: MemberNotification }> = ({ memberNotification }) => {
  const { t: translate } = useTranslation();
  const drugName = memberNotification.drug_name;
  const dtpName = memberNotification.json_message.dtp_name;
  const supList = memberNotification.json_message.supplemental_message;

  useEffect(() => {
    logEvent(ANALYTIC_EVENTS.INBOX.ADHERENCE.adhMessageOpen);
  }, []);

  return (
    <Stack testId="adherence-message-container">
      <Paragraph>{translate("MESSAGE_DETAIL.adherenceMessage.offerSomeInformation")}</Paragraph>
      <Paragraph>
        <Trans
          i18nKey="MESSAGE_DETAIL.adherenceMessage.yourPrescriptionText"
          values={{
            drugName,
            dtpName,
          }}
          components={{ Semibold: <Semibold /> }}
        />
      </Paragraph>
      <Panel>
        {supList.map((drug, index) => (
          <Stack key={index}>
            <Shelf>
              <Icon name="info-circle" color="turquoise" />
              <>{drug}</>
              <Shelf.Spacer />
            </Shelf>
          </Stack>
        ))}
      </Panel>
    </Stack>
  );
};
